import { Injectable } from '@angular/core';
import { SubscriptionsActions } from '@dice/app/store/subscriptions/subscriptions.actions';
import { SubscriptionState, TemporarySubscription } from '@dice/app/types/store.type';
import { Action, State, StateContext } from '@ngxs/store';
import { clone as _clone } from 'lodash';

@State<SubscriptionState>({
  name: 'subscriptions',
  defaults: {
    temporarySubscriptions: [],
  },
})
@Injectable()
export class SubscriptionsState {
  @Action(SubscriptionsActions.Add)
  add(ctx: StateContext<SubscriptionState>, action: SubscriptionsActions.Add): void {
    const { component, subscription } = action;
    const state: SubscriptionState = ctx.getState();
    const { temporarySubscriptions } = state;
    const temporarySubscriptionsCopy: TemporarySubscription[] = _clone(temporarySubscriptions);
    temporarySubscriptionsCopy.push({
      subscription,
      component,
    });
    ctx.setState({
      ...state,
      temporarySubscriptions: temporarySubscriptionsCopy,
    });
  }

  @Action(SubscriptionsActions.Destroy)
  destroy(ctx: StateContext<SubscriptionState>, action: SubscriptionsActions.Destroy): void {
    const { component: currentComponent } = action;
    const state: SubscriptionState = ctx.getState();
    const { temporarySubscriptions } = state;
    const subscriptions: TemporarySubscription[] = [];
    temporarySubscriptions.forEach((temporarySubscription: TemporarySubscription) => {
      const { component, subscription } = temporarySubscription;
      if (typeof component === typeof currentComponent) {
        subscription.unsubscribe();
      } else {
        subscriptions.push(temporarySubscription);
      }
    });
    ctx.patchState({
      temporarySubscriptions: subscriptions,
    });
  }
}
